import React from "react";
//#region types
import { SurveyViewProps } from "models/propTypes/surveyPropsTypes";
import { EntityIdParams } from "models/propTypes/urlParamsTypes";
import { WintSuperkollAPIModelSurveys } from "wint-api-client/dist/types";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { AppState } from "store";
//#endregion
//#region components
import { useParams } from "react-router-dom";
import {
  FormValidity,
  LoadingWithLogo,
  PageLayouts,
  RouteBreadCrumb,
  SimpleEntityTitle,
  useMountedState,
  WizardContextProvider,
} from "components/common";
import { Grid } from "@mui/material";
import SurveyCommentsList from "./surveyCommentsList";
import SurveyFooter from "./footer";
import SurveyFormContainer from "./forms/surveyFormContainer";
import { ErrorView } from "components/error";
import { useSelector } from "react-redux";
import { useSurveyService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SurveyView: React.FC<SurveyViewProps> = (props) => {
  const surveyService = useSurveyService();
  const { getMounted } = useMountedState();
  const urlParams = useParams<EntityIdParams>();
  const id = urlParams.id!;

  const formRef = React.useRef<FormHandles>(null);

  const [notFound, setNotFound] = React.useState<boolean>();
  const [survey, setSurvey] = React.useState<WintSuperkollAPIModelSurveys.Survey>();
  const { name: companyName } = useSelector((state: AppState) => state.auth.selectedCompany);

  const getSurvey = () => {
    surveyService
      .getSurvey(id)
      .then((result) => {
        if (getMounted()) {
          setNotFound(false);
          setSurvey(result);
        }
      })
      .catch((e) => {
        if (!survey) setNotFound(true);
      });
  };

  React.useEffect(() => {
    getSurvey();
  }, [id]);

  const submitSurvey = (isFinal?: boolean) => {
    return (
      (formRef.current && formRef.current.submit(undefined, undefined, !isFinal, isFinal)) ||
      new Promise<void>((resolve) => resolve())
    );
  };

  const reloadSurvey = () => {
    getSurvey();
  };

  return notFound ? (
    <ErrorView />
  ) : (
    <PageLayouts.EntityFullScreen
      id={0}
      entityKey={`survey`}
      navigation={
        <RouteBreadCrumb
          current={survey?.surveyResponse?.isFinal ? survey?.surveyTemplate?.name : TranslationKeys.Common.Submit2}
          showHome
        />
      }
    >
      {survey ? (
        <Grid container className={cssExports.entityCreationLayout} direction="column">
          <Grid item container spacing={3}>
            <Grid item>
              <SimpleEntityTitle title={survey.surveyTemplate?.name ?? ""} status={companyName} />
            </Grid>
            <Grid container item>
              <Grid
                container
                item
                className={
                  survey.surveyResponse?.isFinal
                    ? clsx(cssExports.viewPanelOuter, cssExports.viewPanelSimple)
                    : undefined
                }
              >
                <WizardContextProvider>
                  <FormValidity
                    render={(isValid, onValidityChange) => (
                      <>
                        <SurveyFormContainer
                          ref={formRef}
                          questionGroups={survey.surveyTemplate?.questionGroups ?? []}
                          answers={survey.surveyResponse?.answers ?? []}
                          groupAnswers={survey.surveyResponse?.groupAnswers ?? []}
                          id={survey.id}
                          onFormValidationChange={onValidityChange}
                          isFinal={survey.surveyResponse?.isFinal}
                        />
                        {survey.surveyResponse?.isFinal ? (
                          <></>
                        ) : (
                          <SurveyFooter
                            id={survey.id}
                            submitSurvey={submitSurvey}
                            reloadSurvey={reloadSurvey}
                            isFormValid={isValid}
                            markAsDoneHandler={() => {}}
                          />
                        )}
                      </>
                    )}
                  />
                </WizardContextProvider>
              </Grid>
            </Grid>
            <Grid item sm={12} md={6}>
              {survey.comments && (
                <SurveyCommentsList
                  surveyId={survey.id ?? ""}
                  comments={survey.comments}
                  readonly={survey.surveyResponse?.isFinal}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <LoadingWithLogo />
      )}
    </PageLayouts.EntityFullScreen>
  );
};

export default SurveyView;
